<template>
  <div class="containerFull_FIBAWA">
    <FootballCupCommon
      :containerFullClassName="containerFullClassName"
      :defaultPath="defaultPath"
      :axiosBaseUrl="axiosBaseUrl"
      :sportCompetitionType="sportCompetitionType"
      :themeSeasonArr="themeSeasonArr"
    ></FootballCupCommon>
  </div>
</template>

<script>
// 国际篮联女子亚洲杯 容器
import FootballCupCommon from '@containers/platfrom_football/footballCup_common'
import containerFull_data from '@mixins/basketball/cup/containerFull_FIBAWA_data'
export default {
  name: 'containerFull_FIBAWA',
  mixins: [containerFull_data],
  components: {
    FootballCupCommon,
  },
}
</script>
